export default __webpack_public_path__ + "static/2350-80d656fac3c0df7223eca0998a18049d.gif";